import Icons from '../../constants/Icons'
import TestimonialsSlider from '../CustomSlider/TestimonialsSlider'

const OurGoals = () => {
  return (
    <div>
      <section className='mt-1'>
        <div className='container'>
          <div className='why-aadesh'>
            <h3 className='text-capitalize text-bold mt-2 mb-2'>Our Goals</h3>
            <div className='row p-2'>
              <div className='col-lg-8 pb-3'>
                <div className='row pl-3 '>
                  {[
                    {
                      name: 'Enhance Corporate Travel Solutions:',
                      title:
                        'Create tailored travel packages that prioritize convenience and efficiency for corporate clients.',
                      Icons: Icons.travel1
                    },
                    {
                      name: 'Expand Market Presence:',
                      title:
                        'Build strong relationships with businesses in key markets while maintaining competitive offerings.',
                      Icons: Icons.travel2
                    },
                    {
                      name: 'Cost Optimization for Clients:',
                      title:
                        'Secure preferential rates with airlines and hotels to provide cost-effective travel options.',
                      Icons: Icons.travel3
                    },
                    {
                      name: 'Maintain Superior Client Support:',
                      title:
                        'Offer 24/7 dedicated support to promptly meet corporate travel needs, fostering trust and loyalty.',
                      Icons: Icons.travel4
                    }
                  ].map((items, index) => (
                    <div key={index} className='col-sm-6'>
                      <div className='d-flex align-items-start presence-our'>
                        <div className='icon-box'>
                          <img src={items.Icons} />
                        </div>
                        <div className='corporate-our'>
                          <h5>{items.name}</h5>
                          <p>{items.title}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className='col-lg-4' style={{ position: 'relative' }}>
                <div
                  className='bag-img'
                  style={{
                    position: 'relative',
                    left: '0px',
                    top: '0px',
                    right: '0px',
                    width: '100%',
                    height: '100% ',
                    marginTop: '0px'
                  }}
                >
                  <img
                    src={Icons.planeBug}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain'
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className='testImonials mt-5'>
        <div className='row'>
          <div className='col-lg-4' style={{ position: 'relative' }}>
            <div
              className='about-us-images'
              style={{ position: 'relative', zIndex: '999' }}
            >
              <small className='text-dark-orange'>TESTIMONIALS</small>
              <h3 className='mt-0'>
                What People Say <span className='d-block'>About Us</span>
              </h3>
            </div>
            {/* <img src={Icons.flyingPlan} className='flying-img' /> */}
            <img src={Icons.flying_plan_only1} className='are-round' />
            
          </div>
          <div className='col-lg-8 pr-0 mb-5'>
            <TestimonialsSlider />
          </div>
        </div>
      </section>
    </div>
  )
}
export default OurGoals
